module.exports = __webpack_public_path__ + "img/logo10.1807c7ec.png";